import { Divider, HStack, VStack } from "@gluestack-ui/themed";
import { Button } from "@repo/core/components/core/Button";
import { Icon } from "@repo/core/components/core/Icon";
import { QrCode } from "@repo/core/components/core/QrCode";
import { Tabs } from "@repo/core/components/core/Tabs";
import { Text } from "@repo/core/components/core/Text";
import { PageScaffold } from "@repo/core/components/layout/Scaffolds/PageScaffold";

import SuccessImage from "@repo/core/assets/images/ilustracao-sucesso.svg";
import { ProposalEffectiveSuccessController } from "./controller";
import {
  CLIENT_APP_STORE_TABS,
  CLIENT_APP_STORE_URLS
} from "./constants";
import { Platform } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { getFooterBottomPadding } from "@repo/core/components/layout/Scaffolds/components/ScaffoldFooter/utils";

export const ProposalEffectiveSuccess = () => {
  const insets = useSafeAreaInsets();
  const {
    handleFinish,
    handleGoToSeeLimits,
    isCreditProposal,
    actionInProgress
  } = ProposalEffectiveSuccessController();
  const isActionInProgress = actionInProgress !== null;
  const footerBottomPadding = getFooterBottomPadding(
    Platform.OS,
    insets.bottom
  );
  return (
    <VStack flex={1} w="$full" gap="$3" pt="$4">
      <PageScaffold showHeader={false}>
        <VStack w="$full" gap="$8" pt="$6" pb="$6">
          <VStack w="$full" gap="$6" alignItems="center">
            <SuccessImage />
            <Text
              w="$full"
              fontSize="$xl"
              fontWeight={600}
              color="$textLight900"
              textAlign="center"
            >
              Parabéns! A proposta foi efetivada com sucesso.
            </Text>
            <Text
              w="$full"
              maxWidth="$96"
              color="$textLight900"
              textAlign="center"
            >
              Seu cliente já pode aproveitar todas as vantagens e benefícios do
              cartão WayUp.
            </Text>
          </VStack>
          <Divider w="$full" />
          <HStack w="$full" gap="$3" alignItems="flex-start">
            <Icon name="sms" size={24} color="$primary700" />
            <VStack gap="$1" flex={1}>
              <Text fontWeight={500} color="$textLight900">
                SMS
              </Text>
              <Text fontSize="$sm" color="$textLight800">
                Enviaremos um SMS com todas as informações detalhadas sobre o
                novo cartão, incluindo o número e a senha.
              </Text>
            </VStack>
          </HStack>
          <VStack w="$full" alignItems="center" gap="$4">
            <HStack w="$full" gap="$3" alignItems="flex-start">
              <Icon name="phone" size={24} color="$primary700" />
              <VStack gap="$1" flex={1}>
                <Text fontWeight={500} color="$textLight900">
                  App WayUp
                </Text>
                <Text fontSize="$sm" color="$textLight800">
                  Para a comodidade dele, aconselhamos que o cliente baixe o app
                  WayUp em seu celular, através do QR code:
                </Text>
              </VStack>
            </HStack>
            <VStack w="$full" alignItems="center">
              <Tabs tabs={CLIENT_APP_STORE_TABS}>
                <VStack w="$full" alignItems="center">
                  <QrCode
                    value={CLIENT_APP_STORE_URLS.android}
                    showBorder={false}
                  />
                </VStack>
                <VStack w="$full" alignItems="center">
                  <QrCode
                    value={CLIENT_APP_STORE_URLS.ios}
                    showBorder={false}
                  />
                </VStack>
              </Tabs>
            </VStack>
          </VStack>
          {isCreditProposal && (
            <VStack flex={1} gap="$8" px="$4">
              <HStack flex={1} gap="$3">
                <Icon name="bars-progress" size={20} color="$primary700" />
                <VStack gap="$1" flex={1}>
                  <Text fontWeight={500} color="$textLight900">
                    Limites
                  </Text>
                  <Text fontSize="$sm" color="$textLight800">
                    Apresente ao cliente os seus limites de crédito, caso não o
                    tenha feito ainda.
                  </Text>
                </VStack>
              </HStack>
              <Button
                text="Ver limites"
                leftIcon={{ name: "bars-progress", size: 24 }}
                variant="outline"
                action="darker-secondary"
                onPress={handleGoToSeeLimits}
                isLoading={actionInProgress === "limits"}
                isDisabled={isActionInProgress}
              />
            </VStack>
          )}
        </VStack>
      </PageScaffold>
      <VStack
        w="$full"
        gap="$6"
        py="$6"
        borderRadius="$lg"
        bg="$backgroundLight100"
      >
        <HStack w="$full" gap="$3" px="$4">
          <Icon name="headset" size={20} color="$textLight700" />
          <VStack gap="$1" flex={1}>
            <Text fontWeight={500} color="$textLight900">
              Suporte
            </Text>
            <Text fontSize="$sm" color="$textLight800">
              Caso o cliente não receba o SMS ou para quaisquer dúvidas ou
              necessidades, entre em contato com nosso suporte.
            </Text>
          </VStack>
        </HStack>
      </VStack>
      <VStack w="$full" gap="$3" pb={footerBottomPadding} px="$4">
        {/*   <Button
          text="Ajuda"
          leftIcon={{ name: "circle-question", size: 20, variant: "solid" }}
          variant="outline"
          action="darker-secondary"
          w="$full"
        /> */}
        <Button
          text="Finalizar"
          variant="solid"
          action="primary"
          onPress={handleFinish}
          isLoading={actionInProgress === "finish"}
          isDisabled={isActionInProgress}
          w="$full"
        />
      </VStack>
    </VStack>
  );
};
export default ProposalEffectiveSuccess;
